<template>
    <v-container fluid class="full-height">
        <v-row> <!-- app-row o v-row ?-->
            <v-col cols="12">
                <v-card v-if="loading_page" class="elevation-12 pa-4 full-height">
                    <v-progress-circular
                    indeterminate
                    class="mr-2"
                    color="primary">
                    </v-progress-circular>
                </v-card>
                <v-card v-else-if="screen_data.has_feature" class="elevation-12 pa-4 full-height">
                    <v-card-title class="title-color mb-0 pb-0">
                        <v-row>
                            <v-col cols="3">Informes</v-col>
                            <v-col cols="1"></v-col>
                            <v-col cols="4">
                                <v-select
                                    label="Selector de Informes"
                                    v-model="report_selected"
                                    :items="report_types"
                                    hide-details
                                ></v-select>
                            </v-col>
                            <v-col cols="2">
                                <v-btn
                                    color="primary"
                                    @click="downloadReport"
                                    :loading="screen_data.ui_download_summary_loading">
                                    <v-icon v-once>
                                        mdi-file-excel
                                    </v-icon>
                                </v-btn>
                            </v-col>
                        </v-row>
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="2">
                                <label> {{ date_filter_from_to_labels[0] }} </label>
                                <AppDateField v-model="date_range.after" :disabled=false></AppDateField>
                            </v-col>
                            <v-col cols="2">
                                <label> {{ date_filter_from_to_labels[1] }} </label>
                                <AppDateField v-model="date_range.before" :disabled=false></AppDateField>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12">{{ error_response }}</v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card v-else class="elevation-12 pa-4 full-height">Pantalla no disponible.</v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import { mapGetters, mapActions, mapState, mapMutations} from "vuex"
import { InfraInvoicesProvider } from "@/modules/reporting/infrastructure/InfraInvoicesProvider";
import { DownloadSummaryCommand } from "@/modules/reporting/application/DownloadSummaryCommand";
import { InitReportCommand } from "@/modules/reporting/application/InitReportsCommand";
import { VueFeatureRepository } from '@/modules/shared/infra/FeatureRepository';
import { MemoryS3Repository } from "@/modules/shared/infra/S3Repository";

import AppDateField from "@/modules/widgets/infra/AppDateField.vue";

    export default {
        name:'reports',
        
        components: {
            AppDateField,
        },
        props: {

        },
        async created() {
            this.error_response = ""
            await this.setAfterLogged()
            await this.checkFeature()
            this.loading_page = false
        },
        data() {
            return {
                loading_page: true,
                report_selected: 1,
                date_filter_labels: ["Desde fecha de última modif.", "Hasta fecha de última modif."],
                report_types: [
                    { text: "Contabilizados", value: 1, disabled: false },
                    { text: "No contabilizados", value: 2, disabled: false },
                    { text: "Borrados", value: 3, disabled: false},
                ],
                feature_name: 'feature_reports',
                screen_data: {
                    ui_download_summary_loading: false,
                    has_feature: false
                },
                date_range: {
                    after: '', before: ''
                },
                user_id_num: undefined,
                summary_download_url: undefined,
                error_response: undefined,
            }
        },
        computed:{
            ...mapGetters({
            got_feature:'got_feature',
            userData: 'me/userData'
            }),
            date_filter_from_to_labels() {
                // report_selected = 3 (Borrados) -> Filter by upload date, written date otherwise
                if (this.report_selected == 3)
                    return ["Desde fecha de subida", "Hasta fecha de subida"]
                if (this.report_selected == 1 || this.report_selected == 2)
                    return ["Desde fecha de última modif.", "Hasta fecha de última modif."]
            },
        },
        methods:{
            ...mapActions({
                waitForLoggedIn: "waitForLoggedIn",
                setAfterLogged: "setAfterLogged",
                refreshUserData: "me/refreshUserData"
            }),
            async checkFeature() {
                let feature_repo = new VueFeatureRepository(this.got_feature)
                let cmd = new InitReportCommand(feature_repo, this.feature_name, this.screen_data)
                await cmd.run(this.userData)
            },

            async downloadReport() {
                if (!this.report_selected) {
                    alert("Se debe seleccionar un informe en el selector")
                }
                else {
                    switch(this.report_selected) {
                        case 1:
                            this.downloadSummary(false, true)
                            break
                        case 2:
                            this.downloadSummary(false, false)
                            break
                        case 3:
                            this.downloadSummary(true, null)
                            break
                        default:
                            console.error("Error inesperado")
                    }
                }
            },

            async downloadSummary(get_deleted, done_filter) {
                let invoices_provider = new InfraInvoicesProvider()
                const s3_repo = new MemoryS3Repository()
                let cmd
                if (!get_deleted) {
                    cmd = new DownloadSummaryCommand(invoices_provider, this.screen_data, this.date_range, done_filter)
                }
                else {
                    cmd = new DownloadSummaryCommand(invoices_provider, this.screen_data, this.date_range, done_filter, true) // 'true' is arg 'get_deleted'
                }
                let cmd_output = await cmd.run(this.user_id_num)
                if (typeof cmd_output === "object") {
                    if (!cmd_output) {
                        this.summary_download_url = null
                        this.error_response = "La consulta no ha devuelto ningún resultado."
                    }
                    else {
                        this.summary_download_url = cmd_output
                        this.error_response = cmd_output["error"]
                    }
                }
                else if (typeof cmd_output === "string") {
                    this.error_response = ""
                    this.summary_download_url = cmd_output

                    this.download_from_url(this.summary_download_url)
                }
            },

            async download_from_url(url) {
                const response = await fetch(url);
                const blob = await response.blob();

                // For other browsers: create a link pointing to the ObjectURL containing the blob.
                const objUrl = window.URL.createObjectURL(new Blob([blob]));
                const link = document.createElement("a");
                link.href = objUrl;
                link.download = "summary.csv";
                link.click();

                // For Firefox it is necessary to delay revoking the ObjectURL
                setTimeout(() => { window.URL.revokeObjectURL(objUrl); }, 250);
            }
        },
        mounted() {
        },
    }
</script>

<style lang="scss" scoped>
    .buttom-border {
        border-bottom-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-head{
        border-left-style:solid;
        border-right-style:solid;
        /* border-bottom-style:solid; */
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-row{
        border-left-style:solid;
        border-right-style:solid;
        border-bottom-style:solid;  
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .table-name {
        border-left-style:solid;
        border-color:var(--v-primary-base);
        border-width: thin;
    }
    .final-row {
        border-right-style:solid;
    }

    .cdb__go-detail {
        cursor: pointer;
        color: var(--v-primary-base);
        text-decoration: underline;
    }

    .full-height {
        height: 100%;
        display: flex;
        flex-direction: column;
    }
</style>